export const PUBLIC_DASHBOARD_HOSTS = [
    "public.ark-climate.de",
    "public.staging.ark-climate.de",
    "public.localhost",
];
const PUBLIC_HOST_SET = new Set(PUBLIC_DASHBOARD_HOSTS);
export function isPublicDashboardHost(host) {
    return PUBLIC_HOST_SET.has(host.toLowerCase());
}
